<ion-list *ngIf="notFound">
    <div class="img-not-found">
        <img *ngIf="!isMessianica" src="../../../assets/imgs/img.png" class="not-found" />
        <img *ngIf="isMessianica" src="../../../assets/imgs/not-found-messianica.png" class="not-found" />
    </div>

    <p class="not-msg">
        {{text | translate}}
    </p>
</ion-list>

<ion-list *ngIf="!notFound">
    <div class="img-access-found">
        <img src="../../../assets/imgs/acesso-negado.png" class="access-found" />
    </div>

    <p class="access-msg">
        {{text | translate}}
    </p>
</ion-list>